import axios from 'axios'
import Vue from 'vue'


export async function crearTicket(context, payload){
    try{
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let url = "api/addticket"//direccion de la api
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=') // siempre agregar el token
        values.append('solicitante_id',payload.solicitante)
        values.append('titulo',payload.titulo)      
        values.append('descripcion',payload.descripcion)      
        values.append('categoria_id',payload.categoria)  
        values.append('maquina_id', payload.maquina)    
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        //si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.commit('setIsOk', true);
        //context.dispatch('fetchOrdenes')
    }catch(error){
        context.commit('ticketError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function subirImagen(context, payload){
    try{
        context.commit('setLoading',true,{root:true})//lanzamos el loading
        context.commit('setIsOk',false)//seteamos la respuesta en falso
        let url = "api/uploadimage"
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=') // siempre agregar el token
        values.append('image',payload.image)
        values.append('id',payload.id)
        await Vue.axios({
            method:"POST",
            url:url,
            data:values,
            contentType: false,
            processData: false,
        },
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }

        },
        )
        //console.log('SUCCESS!!');
    }
    catch(error){
        context.commit('ticketError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}// subirImagen

/**
 * Metodo que trae todos los tickets
 * @param {*} context 
 * @param {*} payload 
 */
export async function fetchTickets(context,payload){
    try{
        context.commit('flushTickets')//limpia el arreglo
        let url = "api/gettickets"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setTickets', response.data)

    }catch(error){
        context.commit('ticketError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}// fetchTickets
/**
 * metodo que devuelve las imagenes del ticket
 * @param {*} context 
 * @param {*} payload 
 */
export async function fetchImages(context,payload){
    try{
        let url = "api/getticketimages"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setImages', response.data)

    }
    catch(error){
        context.commit('ticketError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}


export async function fetchActivity(context, payload){
    try{
        context.commit('setLoading',true,{root:true})//lanzamos el loading
        context.commit('setIsOk',false)//seteamos la respuesta en falso
        let url = "api/getactivityticket"
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=') // siempre agregar el token
        values.append('id',payload.id)
        let response = await Vue.axios({
            method:"POST",
            url:url,
            data:values,
            
        })
        context.commit('setActivity', response.data)
    }
    catch(error){
        context.commit('ticketError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}// fetchActivity

export async function fetchTicketTotal(context, payload){
    try{
        let url = "api/gettickettotal"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setTotal', response.data)
        
    }
    catch(error){
        context.commit('ticketError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}


export async function fetchTicketTotalAbierto(context, payload){
    try{
        let url = "api/gettickettotalabierto"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setTotalAbierto', response.data)
        
    }
    catch(error){
        context.commit('ticketError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}


export async function fetchTicketTotalCerrado(context, payload){
    try{
        let url = "api/gettickettotalcerrado"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setTotalCerrado', response.data)
        
    }
    catch(error){
        context.commit('ticketError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

/**
 * Agrega una actividad al ticket
 * @param {*} context 
 * @param {*} payload 
 */
export async function crearActividad(context, payload){
    try{
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let url = "api/addticketactivity"//direccion de la api
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=') // siempre agregar el token
        values.append('ticket_id',payload.ticket_id)
        values.append('user_id',payload.user_id)
        values.append('descripcion',payload.descripcion)      
        values.append('estado',payload.estado)      
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        //si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.commit('setIsOk', true);
    }catch(error){
        context.commit('ticketError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}
/**
 * metodo que busca los tickets por id de usuario
 * @param {*} context 
 * @param {*} payload 
 */
export async function fetchTicketsByUser(context,payload){
    try{
        context.commit('flushTickets')//limpia el arreglo
        let url = "api/getticketsbyuser"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        values.append('id',payload.id)
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })

        context.commit('setTickets', response.data)

    }catch(error){
        context.commit('ticketError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}// fetchTickets

export async function cerrarTicket(context, payload){
    try{
        context.commit('setLoading',true,{root:true})
        let url = 'api/cerrarticket'
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        values.append('id',payload.id)
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        //si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.commit('setIsOk', true);
    }catch(error){
        context.commit('ticketError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}